module.exports = function(fn){
  return function(e){
    if(e && e.preventDefault){
      e.preventDefault();
    }
    if(e && e.stopPropagation){
      e.stopPropagation();
    }
    fn.call(this, e);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms.bootstrap3/inputs/Date/wrapPreventDefault.js
// module id = 96
// module chunks = 0 1 2 3 4